module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"locationCount":"{count} locations","locationGroupCount":"{count} location groups"},"de":{"locationCount":"{count} Standorte","locationGroupCount":"{count} Standortgruppen"},"fr":{"locationCount":"{count} emplacements","locationGroupCount":"{count} groupe d\u0027emplacements"},"it":{"locationCount":"{count} posizioni","locationGroupCount":"{count} gruppo di posizioni"}}')
  delete Component.options._Ctor
}
